import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {InventoryCustomObjectSearchModel} from "../inventory-custom-object-search.model";
import {CustomObjectSearchPageComponent} from "./custom-object-search-page.component";
import {InventoryCustomObjectEntityModel} from "../inventory-custom-object-entity.model";
import {CustomObjectSearchModel} from "../custom-object-search.model";

@Component({
    selector: "wbo-inventory-custom-object-search-page",
    templateUrl: "custom-object-search-page.component.html",
    providers: [provideSearchModel(InventoryCustomObjectSearchModel), provideEntityModel(InventoryCustomObjectEntityModel)]
})
export class InventoryCustomObjectSearchPageComponent extends CustomObjectSearchPageComponent {
    override inventoryContext: boolean = true;

    constructor(searchModel: InventoryCustomObjectSearchModel) {
        super(searchModel);
    }
}
